<template>
  <div class="et-layer" ref="layerContainerRef">
    <div class="et-layer-item" ref="layerItemRefs" :data-uuid="elem.uuid" :data-index="index"
      @mousedown="(event) => onMouseDown(event, index)" :class="{ active: getActive(elem) }"
      v-for="(elem, index) in data.elements">
      <div class="et-layer-icon">
        <img :src="getImgSrcByName(elem.type)">
      </div>
      <div class="et-layer-name">
        {{ getElementName(elem) }}
      </div>
      <div class="et-layer-type">
        {{ elem.type }}
      </div>
      <div>
        {{ elem.zIndex }}
      </div>
    </div>
    <div class="et-layer-indicator" :style="{ top: data.it + 'px', display: display }"></div>

  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch, inject, nextTick, onActivated, onDeactivated } from 'vue'
import { transformToLocal } from '../../core/utils/index.js'
import { getImgSrcByName } from "@/topo/core/utils/img-load.js"

/**
 * @type {import('../topology').Topology}
 */
const topology = inject('topology')
const data = reactive({
  elements: [],
  selected: null,
  it: 0,
})


topology.addEventListener('topo:select', (event) => {

  updateElements()

  if (event.data) {
    data.selected = event.data.uuid
  } else {
    data.selected = null
  }
  // 滚动到选中的元素
  scrollIntoActive()

})

function getElementName(elem) {
  return elem.name || '<未命名>'
}

function updateElements() {
  data.elements = topology.storage.displayElement.map((elem) => {
    return {
      uuid: elem.uuid,
      type: elem.type,
      name: elem.name,
      zIndex: elem.g.getZIndex(),
    }
  })
  data.elements.sort((a, b) => {
    return b.zIndex - a.zIndex
  })
}


function scrollIntoActive() {
  nextTick(() => {
    const elem = document.querySelector(`.et-layer-item.active`)
    if (elem) {
      elem.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
      })
    }
  })
}


function getActive(elem) {
  return elem.uuid === data.selected
}









let isMouseDown = false
let layerContainerRef = ref(null)
let cp = null
let offsetY = 0
let layerItemRefs = ref([])
let display = ref('none')
let sourceIndex = -1

function onMouseDown(event, index) {
  if (event.button !== 0) {
    return
  }

  isMouseDown = true
  sourceIndex = index

  const containeRectangle = layerContainerRef.value.getBoundingClientRect()
  const downElem = event.target.closest('.et-layer-item')
  const downElemRectangle = downElem.getBoundingClientRect()
  cp = downElem.cloneNode(true)
  cp.style.position = 'absolute'
  // 相对位置
  cp.style.top = downElemRectangle.top - containeRectangle.top + layerContainerRef.value.scrollTop + 'px'
  cp.style.left = '4px'
  cp.style.width = '100%'
  cp.style.opacity = 0.8
  cp.style.zIndex = 10
  cp.style.border = '1px dashed #88f'

  layerContainerRef.value.appendChild(cp)
  layerContainerRef.value.style.pointerEvents = 'none'

  // 计算偏移量
  const rect = cp.getBoundingClientRect()
  offsetY = event.pageY - rect.top - layerContainerRef.value.scrollTop

}

let targetElem
let sourceElem

window.addEventListener('mousemove', (event) => {
  if (isMouseDown) {
    const rect = layerContainerRef.value.getBoundingClientRect()
    const dy = event.pageY - rect.top - offsetY
    cp.style.top = dy + 'px'

    const mouseRelativeTop = event.pageY - rect.top

    for (const element of layerItemRefs.value) {
      const { y } = transformToLocal(element, layerContainerRef.value)
      const index = element.dataset.index
      const mouseY = mouseRelativeTop + element.clientHeight / 2

      if (mouseY > y && mouseY < y + element.clientHeight) {
        console.log({ index });
        display.value = 'block'
        data.it = y + layerContainerRef.value.scrollTop

        targetElem = data.elements[index]
        sourceElem = data.elements[sourceIndex]

      }
    }

  }
})


window.addEventListener('mouseup', (event) => {
  isMouseDown = false
  layerContainerRef.value && (layerContainerRef.value.style.pointerEvents = 'auto')
  display.value = 'none'
  data.it = 0

  if (targetElem && sourceElem && targetElem !== sourceElem) {
    console.log({ targetElem, sourceElem });
    // 交换两个元素的zIndex
    const tempZIndex = sourceElem.zIndex
    topology.storage.setZIndex(sourceElem.uuid, targetElem.zIndex)
    topology.storage.setZIndex(targetElem.uuid, tempZIndex)

    updateElements()

    targetElem = null
    sourceElem = null
  }


  if (cp) {
    cp.remove()
    cp = null
  }
})



// //////////////
updateElements()

onActivated(() => {
  updateElements()
  scrollIntoActive()
})

</script>
<style scoped>
.et-layer {
  padding: 0 2px;
  user-select: none;
  position: relative;
}

.et-layer-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.et-layer-icon>img {
  max-width: 16px;
  max-height: 16px;
}

.et-layer-item {
  height: 28px;
  padding: 0 8px;
  margin-top: 2px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.et-layer-item:hover {
  background: rgba(58, 81, 145, 0.85);
}

.et-layer-item.active {
  background: #3f51b5;
}

.et-layer-item:focus-visible {
  outline: 2px solid #178ffc;
  outline-offset: 1px;
}

@media (prefers-reduced-motion: reduce) {
  .et-layer-item {
    transition: none;
  }
}

.et-layer-name {
  /* color: #fff; */
  margin: 0 8px;
}

.et-layer-type {
  color: rgba(255, 255, 255, 0.476);
}

.et-layer-indicator {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 2px;
  background: #00ffff;
  z-index: 10;
  display: none;
}

.et-layer-indicator::after {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #00ffff;
  content: '';
  left: 0;
  top: -4px;
}
</style>
